const ITEMS = [
  "Optical Fiber Infrastructure",
  "Telecom Equipment Supply",
  "Underground OFC Laying",
  "Aerial OFC Deployment",
  "Fiber Splicing & Testing",
  "Fiber Lease & Rental",
  "Co-location Support",
  "RF Connectivity",
  "Telecom Civil Works",
  "24/7 Infrastructure Support",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-navy-900 py-5"
      aria-hidden="true"
    >
      <div className="animate-jtk-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-heading text-sm font-semibold uppercase tracking-[0.3em] text-slate-500">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-cyan-500/50" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-900 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-900 to-transparent" />
    </div>
  );
}
